import {withRetry} from './axios'
import { ANY, DEVELOPMENT, IFilters, RawFilters } from "../utils";


export async function getFilters(): Promise<RawFilters> {
  if (process.env.REACT_APP_MODE === DEVELOPMENT) {
    return fakeFilters
  }
  // return fakeFilters

  
  const res = await withRetry(async (instance) => {return instance.get('/filters')})
  const {filters} = await res.data
  return filters
}

export async function updateFilters(filters: IFilters): Promise<void> {
  if (process.env.REACT_APP_MODE === DEVELOPMENT) {
    return
  }

  await withRetry(async (instance) => {return instance.patch('/filters', {filters})})

  return;
}

var fakeFilters: RawFilters = {
  // city: {label: 'Москва', value: 'Москва'},
  experience: ANY,
  keyWords: "JS;REACT",
  companies: "SBER",
  filterByCompanies: false
}